import gql from 'graphql-tag';

export const ACCOUNT_QUERY = gql`
query getAccount($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      isHeadOfFamily
      localAriFields {
        id
        rank
        dataType
        question
        answers
        mandatory
      }   
      globalAriFields {
        id
        rank
        dataType
        question
        answers
        mandatory
        enabled
        accountsWithFieldEnabled {
          id
          displayName
        }
        availableAccountsToEnable {
          id
          displayName
        }
      }
      subAccountsLocalFieldUseEnabled
      canUseLocalAriFields
      canCreateGlobalAriFields
      globalAriFieldsEnabledForSuperLinks
      localAriFieldsEnabledForSuperLinks
      globalAriFieldsEnabledForQuestionnaires
      localAriFieldsEnabledForQuestionnaires
    }
  }  
`;

export const USER_AGREEMENT = gql`
 query getUserAgreement($first: Int) {
  viewer {
    id
    accounts (first: $first){
      edges {
        agreedToGdprTerms
        node {
          id
          displayName
        }
      }
    }
  }
}
 `;
